export default "__VITE_ASSET__Dmgn26po__"